import React from 'react';
import { css } from '@emotion/react';
import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { color } from '@/styles';
import { t } from 'i18next';

const TooltipTrigger = css`
  display: inline-flex;
  align-items: center;
  cursor: help;
`;

interface RawGraphHintTooltipProps {
  size?: number;
  iconColor?: string;
}

const TooltipBody = css`
  font-size: 12px;
  line-height: 1.4;
`;

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.arrow}`]: {
    color: color.bg_light_green,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    color: color.dark_gray,
    backgroundColor: color.bg_light_green,
    maxWidth: 208,
    padding: '8px 12px',
  },
});

const RawGraphHintTitle = t(
  'rawDataDirectlyMeasuredByTheDFreeSensorBeforeCorrection',
  'DFreeセンサが直接検知している補正する前の生データです',
);

export const RawGraphHintTooltip = React.memo(({ size = 18, iconColor = color.gray }: RawGraphHintTooltipProps) => {
  return (
    <StyledTooltip
      title={<div css={TooltipBody}>{RawGraphHintTitle}</div>}
      placement='bottom'
    >
      <span css={TooltipTrigger}>
        <InfoOutlined sx={{ fontSize: size, color: iconColor }} />
      </span>
    </StyledTooltip>
  );
});
